import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useGetClassesForListMutation } from '../../../../../features/authentication/classesApiSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { useItemAnalysisContext } from '../utils/itemAnalysisContext';
import DropDownSelect from '../../../../../../src/components/DropDownSelect/index';

const ClassSelects = ({loadClassAssignments,handleCancelClick}) => {
  const [searchClass, setSearchClass] = useState('');
  const [selectAll, setSelectAll] = useState(false);

  const [getClassesForList] = useGetClassesForListMutation();
  const { classes, setClasses, includeRemoved, setIncludeRemoved, activeStep } = useItemAnalysisContext();
  const [selectedClasses, setSelectedClasses] = useState(null);
  const [classDropdownValues, setClassDropdownValues] = useState(null);
  
  useEffect(() => {
    if (!classes)
      loadClasses();

    if (activeStep == 2) {
      setSelectedClasses(classes.filter(x => x.selected));
      setClassDropdownValues(classes.filter(x => !x.selected));
    }
  }, []);

  const handleCheckAllChange = (checked) => {
    setSelectAll(checked);
    var modifiedClasses = classes?.map((item) => {
      return ({ ...item, selected: checked });
    });
    setClasses(modifiedClasses);
  };

  const loadClasses = async () => {
    var result = await getClassesForList().unwrap();
    var classes = result.map((item) => {
      return ({ ...item, selected: false });
    });
    setClasses(classes);
  };

  const singleCheck_OnChange = async (id, status) => {
    var updatedClasses = [...classes.map(x => x.id == id ? { ...x, selected: status } : { ...x })];
    setClasses(updatedClasses);

    if (updatedClasses.filter(x => x.selected).length == classes.length)
      setSelectAll(true);
    else
      setSelectAll(false);
  };

  const selectedCheck_OnChange = async (id, status) => {
    var updatedClasses = [...selectedClasses.map(x => x.id == id ? { ...x, selected: status } : { ...x })];
    setSelectedClasses(updatedClasses);
  };

  const handleRemoveAll = () => {
    setSelectedClasses(null);
    setClassDropdownValues(classes.filter(x=>!x.selected));
  };

  const handleAddNewClass = (e) => {
    var newClass = {...classes.find(x=>x.id == e.key), selected : true};
    var selectedItems = selectedClasses ? [...selectedClasses]:[];
    selectedItems.push(newClass);

    var notSelectedItems = classes.filter(x=> !selectedItems.map(y=>y.id).includes(x.id));
    setClassDropdownValues(notSelectedItems);
    setSelectedClasses([...selectedItems]);
  };

  const handleSaveSelected = ()=>{
    var selectedClassIds = selectedClasses?.filter(x=>x.selected).map(x=>x.id);
    var updatedClass = [...classes.map(x=> selectedClassIds?.includes(x.id) ? {...x, selected: true}: {...x, selected: false})];
    setClasses(updatedClass);
    loadClassAssignments(!selectedClassIds?[]:selectedClassIds);
    handleCancelClick();
  };


  return (
    <div className='m-4'>
      {activeStep == 1 && <> <Row><Col><label className='fw-medium'>Choose Classes</label></Col></Row>
        <Row className='my-4'>
          <Col>
            <div className="custom-search position-relative">
              <FontAwesomeIcon icon={faSearch} />
              <input
                type="search"
                className={'form-control'}
                value={searchClass}
                onChange={(e) => { setSearchClass(e.target.value); }}
                placeholder='Search Class'
              />
            </div>
          </Col>
        </Row>
        <Row className='mb-4'>
          <Col>
            <div className='d-flex flex-row align-items-center form-check'>
              <input
                type="checkbox"
                className="form-check-input me-2 cursor-pointer"
                checked={selectAll}
                id="checkAll"
                name="allselect"
                onChange={() => handleCheckAllChange(!selectAll)}
              />
              <label  htmlFor='checkAll' className="form-check-label">
                Select All
              </label>
            </div>
          </Col>
          <Col className='d-flex justify-content-end'>
            <div className='d-flex flex-row align-items-center form-check'>
              <input
                type="checkbox"
                className="form-check-input me-2 cursor-pointer"
                checked={includeRemoved}
                id="includeRemoved"
                name="allselect"
                onChange={() => setIncludeRemoved(!includeRemoved)}
              />
              <label  htmlFor='includeRemoved' className="form-check-label">
                Include removed students
              </label>
            </div>
          </Col>
        </Row></>
      }
      {activeStep == 2 &&
        <Row className='mb-3'>
          <Col>
            <label className='pb-2'>Select Class</label>
            <DropDownSelect
              value={classDropdownValues}
              onChange={(e) => handleAddNewClass(e)}
              dropdownId="newClassSelect"
            />
          </Col>
        </Row>
      }
      <Row>
        {(activeStep == 2 ? selectedClasses : classes)?.filter(x => x.name.toLowerCase().includes(searchClass?.toLowerCase()))?.map((item, index) => (
          <Col className='col-sm-4' key={`c_${index}`}>
            <div className='box-border mb-3 p-3 rounded-2'>
              <div className='d-flex flex-row align-items-center form-check'>
                <input
                  type="checkbox"
                  className="form-check-input me-2 cursor-pointer"
                  checked={item.selected}
                  id={`c_${index}`}
                  name="classes"
                  onChange={() => activeStep == 1 ? singleCheck_OnChange(item.id, !item.selected) : selectedCheck_OnChange(item.id, !item.selected)}
                />
                <div>
                  <Row>
                    <Col>
                      <label htmlFor={`c_${index}`} className="form-check-label fs-14">
                        {item.name}
                      </label>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      {item.coTeacherClass && <span className="badge badge-info-light fw-normal fs-10">
                        <i className="fa-solid fa-user-gear"></i> {item.teacherName}
                      </span>
                      }
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </Col>
        ))}
      </Row>
      {activeStep == 2 &&
      <>
        <Row>
          <Col className='col-3 cursor-pointer mt-3 text-castleOrange' onClick={() => handleRemoveAll()}><FontAwesomeIcon icon={faTrashAlt} /> <span>Remove All Selected</span></Col>
        </Row>
        <Row className='justify-content-end mt-4'>
          <Col className='col-3'>
            <div className='d-flex justify-content-end'>
              <button className='btn btn-castleGray flex-grow-1 mr-2'
                onClick={() => handleCancelClick()}
              >
                    Cancel
              </button>
              <button
                className='btn btn-castleRed flex-grow-1'
                onClick={() => handleSaveSelected()}
              >
                    Save&nbsp;
              </button>
            </div>
          </Col>
        </Row>
      </>}
    </div>
  );
};

ClassSelects.propTypes = {
  handleCancelClick: PropTypes.func,
  loadClassAssignments: PropTypes.func
};

export default ClassSelects;